import { Redirect } from 'models/redirect';
import {Agent, request} from './base';

export class RedirectsAgent extends Agent<Redirect> {
    constructor() {
        super(Redirect, '/redirects');
    }

    sync = async () => {
        await request.post('/redirects/sync', {});
    };
}
